<template>
  <div
    v-if="visible"
    class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
    style="z-index: 9999"
    @click="handleBackdropClick"
    @keydown.esc="handleCancel"
    tabindex="0"
    ref="modalBackdrop"
  >
    <div
      class="bg-white rounded-lg shadow-lg w-full max-w-sm p-3 flex flex-col gap-4"
      @click.stop
    >
      <h2 class="text-lg font-semibold">{{ title }}</h2>
      <p class="text-gray-700">{{ message }}</p>
      <div class="flex justify-end gap-2">
        <button
          class="px-4 py-2 text-sm bg-gray-300 rounded hover:bg-gray-400 border"
          @click="handleCancel"
        >
          {{ translate('Cancel') }}
        </button>
        <button
          class="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700 border"
          @click="handleConfirm"
        >
          {{ translate('Confirm') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { translations } from '@/mixins';

export default {
  name: 'ConfirmationModal',
  mixins: [translations],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Are you sure?',
    },
    message: {
      type: String,
      default: 'Do you want to proceed?',
    },
  },
  emits: ['confirm', 'cancel', 'update:visible'],
  methods: {
    handleConfirm () {
      this.closeModal();
      this.$emit('confirm');
    },
    handleCancel () {
      this.closeModal();
      this.$emit('cancel');
    },
    handleBackdropClick (event) {
      // Only close if clicking the backdrop itself, not the modal content
      if (event.target === this.$refs.modalBackdrop) {
        this.handleCancel();
      }
    },
    closeModal () {
      this.$emit('update:visible', false);
    },
  },
};
</script>
